module.exports = __webpack_public_path__ + "static/media/contact-us-bg.2922ec65.png";